module.exports = __webpack_public_path__ + "static/media/view3.48c8531b.jpg";